/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IngestEventRequest { 
    apiKey?: string | null;
    email?: string | null;
    bookId?: string | null;
    eventType?: string | null;
    userId?: string | null;
}

